import * as React from 'react';
import { SingleOfferSearchButton } from '@shared-ui/lodging-property-offers';
import { SharedUiSubmitButtonWrapper } from 'components/infosite/shared-ui/form/field-wrappers';
import { withSharedUiPropertyOffers } from './shared-ui-property-offers';
const SingleOfferSearchButtonComponent = ({
  inputs
}) => React.createElement(SingleOfferSearchButton, {
  inputs: inputs,
  ButtonWrapper: SharedUiSubmitButtonWrapper,
  skipSsr: true
});
SingleOfferSearchButtonComponent.displayName = 'SingleOfferSearchDateFieldComponent';
export const SharedUiSingleOfferSearchButtonWrapper = withSharedUiPropertyOffers(SingleOfferSearchButtonComponent);